import { useQuery } from '@tanstack/react-query';
import { fetchTemplateVersion } from '../services/documentTemplates';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useTemplateVersionQuery = (templateId: string, versionId: string | null) =>
  useQuery({
    queryKey: documentTemplateKeys.version(templateId, versionId ?? ''),
    queryFn: () => fetchTemplateVersion(templateId, versionId as string),
    enabled: Boolean(versionId),
  });
